const state = {
  isLoggedIn: false,
  isBootstrapLoading: true,
  isBootstrapReLoading: false,
  currentClient: null,
  currentClientConfig: {},
  data: null,
  showTermsDialog: false,
  environmentVariables: {},
  mdmBoostrap: {},
  hideFilter: false,
  isPaymentError: false,
};

export default state;
